<template>
    <div 
        class="d-flex flex-column cardWrapper mb-16"
        :style="posicaoCard === 'esquerda' ? 'margin-left: 64px; justify-self: flex-start' 
                : posicaoCard === 'centro' ? 'justify-self: center'
                : posicaoCard === 'direita' ? 'margin-right: 64px; justify-self: flex-end' 
                : 'margin-left: 64px; justify-self: flex-start' "
    >
        <div class="d-flex colabDetails">
                <v-icon
                    v-if="colabData.dsc_fonte_colaboracao.toLowerCase() !== 'socialcam'"
                    class="ml-4 mt-2" 
                    color="#FFFFFF">{{ getFontIcon() }}
                </v-icon>
                <span 
                    style="display:inline-block; color: #FFFFFF; font-weight: 700; font-size: 1.1rem; margin: 0;" 
                    class="ml-4 mt-2"
                >
                    {{ colabData?.dsc_nome_colaborador }}
                </span>
        </div>
        <div class="d-flex secondRow">
            <div 
                class="d-flex"
                style="padding: 0; width: 100%;"    
            >
                <div class="avatarWrapper mx-0 px-0">
                    <img
                        class="mx-0 px-0"
                        width="100%"
                        v-if="colabData.flg_sem_avatar === 'N'"
                        :src="colabData.url_avatar_colaborador"
                    />
                    <FakeAvatar
                        class="d-flex align-center px-3 py-3"
                        style="background: #323232; width: 110px; height: 110px;"
                        v-if="colabData.flg_sem_avatar === 'S'" />
                </div>
                <div class="textoColaboracaoWrapper">
                    <p 
                        class="ml-4 mr-2 my-2"
                        :style="colabData.dsc_texto_colaboracao.trim().length > 230 && !['sm', 'md'].includes(breakpoint) ?
                                'font-size: 1.1rem; line-height: 1.6rem' : ' ' "
                    >
                        {{ colabData.dsc_texto_colaboracao }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FakeAvatar from "@/assets/fake-avatar.svg";
export default {
    props: {
        colabData: Object,
        posicaoCard: String
    },
    components: {
        FakeAvatar
    },
    data() {
        return {
            breakpoint: null,
        }
    },
    created() {
        this.breakpoint = this.$vuetify.breakpoint.name;
    },
    methods: {
        getFontIcon() {
            switch(this.colabData.dsc_fonte_colaboracao.toLowerCase()) {
                case "twitter":
                    return "mdi-twitter";
                case "whatsapp":
                    return "mdi-whatsapp";
                case "instagram":
                    return "mdi-instagram"
                default:
                    return "mdi-web"
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.cardWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 60%;
}
.colabDetails {
    max-width: 100%;
    min-height: 40px;
    background: #323232 !important;

    .v-icon {
        width: 24px !important;
        height: 20px !important;
    }
    .v-icon::before {
        width: 24px !important;
        height: 20px !important;
    }
}

.secondRow {
    max-width: 100%;
}
.textoColaboracaoWrapper {
    background: #F5F5F5 !important;
    width: calc(100% - 110px);
    max-height: 110px;
    vertical-align: middle;
    display: table-cell;
    text-align: left;

    p {
        font-weight: 400;
        vertical-align: middle;
        color: #323232;
        line-height: 29px;
        font-size: 1.1rem;
        // font-size: 2.5vh;
    }
}

.avatarWrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    min-width: 110px;
    max-height: 110px;

    img {
        max-width: 110px !important;
        height: 100% !important;
    }
}

@media screen and (min-width: 576px) and (max-width: 767.98px){
    .cardWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80%;
}
.colabDetails {
    max-width: 100%;
    min-height: 40px;
    background: #323232 !important;

    .v-icon {
        width: 20px !important;
        height: 16px !important;
    }
    .v-icon::before {
        width: 20px !important;
        height: 16px !important;
    }
}

.secondRow {
    max-width: 100%;
}
.textoColaboracaoWrapper {
    background: #F5F5F5 !important;
    width: calc(100% - 110px);
    max-height: 110px;
    vertical-align: middle;
    display: table-cell;
    text-align: left;

    p {
        font-weight: 400;
        vertical-align: middle;
        color: #323232;
        line-height: .9rem;
        font-size: .7rem;
        // font-size: 2.5vh;
    }
}

.avatarWrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    min-width: 110px;
    max-height: 110px;

    img {
        max-width: 110px;
        min-height: 110px;
    }
}
}

@media screen and (max-width: 577.98px){
    .cardWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80%;
}
.colabDetails {
    max-width: 100%;
    min-height: 1px;
    background: #323232 !important;

    .v-icon {
        width: 10px !important;
        height: 8px !important;
    }
    .v-icon::before {
        width: 10px !important;
        height: 8px !important;
    }
}

.secondRow {
    max-width: 100%;
}
.textoColaboracaoWrapper {
    background: #F5F5F5 !important;
    width: calc(100% - 80px);
    max-height: 80px;
    vertical-align: middle;
    display: table-cell;
    text-align: left;

    p {
        font-weight: 400;
        vertical-align: middle;
        color: #323232;
        line-height: 1.1rem;
        font-size: .825rem;
        // font-size: 2.5vh;
    }
}

.avatarWrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    max-height: 80px;

    img {
        max-width: 80px;
        min-height: 80px;
    }
}
}
</style>